import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FuseDrawerModule } from '@fuse/components/drawer';
import { MatButtonModule } from '@angular/material/button';
import { ReportBugComponent } from './report-bug.component';
import { DialogBugInfoComponent } from './dialog-bug-info/dialog-bug-info.component';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

@NgModule({
    declarations: [
        ReportBugComponent,
        DialogBugInfoComponent
    ],
    imports     : [
        CommonModule,
        RouterModule,
        MatIconModule,
        MatTooltipModule,
        FuseDrawerModule,
        MatButtonModule,
        MatInputModule,
        MatFormFieldModule
    ],
    exports     : [
        ReportBugComponent
    ]
})
export class ReportBugModule
{
}
